module.exports = __webpack_public_path__ + "static/media/package_develop_web_app.c2167e3d.svg";